import type { Order, OrderRevisionNote } from "../types/order";

export const getActiveRevisionNote = (order: Pick<Order, "revisionNote">): string | undefined => {
  return order.revisionNote?.note;
};

export type { OrderRevisionNote };
